<template>
  <div id="app" :class="appClass">
    <router-view v-if="show"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return { show: true };
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  computed: {
    isAdminRoute() {
      return this.$route && this.$route.path && this.$route.path.startsWith('/admin');
    },
    appClass() {
      return {
        'theme-yellow': !this.isAdminRoute,
        'theme-default': this.isAdminRoute
      };
    }
  },
  methods: {
    // 高阶组件定义刷新方法
    reload() {
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}
.line {
  width: 90%;
  max-width: 1200px;
  height: 2px;
  background-color: #ccc;
  margin: 50px auto;
}

/* 响应式断点 */
@media (max-width: 1024px) {
  .line {
    width: 95%;
    margin: 30px auto;
  }
}

@media (max-width: 768px) {
  .line {
    width: 90%;
    margin: 20px auto;
  }

  .case-mobile-message-box {
    position: fixed;
    top: 50%;
    left: 50%;
    width: calc(100vw - 24px);
    max-width: calc(100vw - 24px);
    margin: 0;
    transform: translate(-50%, -50%);
  }
}
a {
  text-decoration: none;
  color: black;
  cursor: pointer;
}
a:hover {
  color: var(--brand-yellow-dark, #d7ac1b);
}
</style>
